module.exports = __webpack_public_path__ + "img/account-info.bcbd675f.svg";